import * as Auth from 'src/models/Auth';

export const AUTH_STORAGE_KEY = 'auth';

class AuthStore {
  get(): Auth.Auth {
    const json = localStorage.getItem(AUTH_STORAGE_KEY);
    const obj = (json && JSON.parse(json)) || {};
    return obj.claims;
  }
  set(auth: any) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
  }
  remove() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
}

export { AuthStore };
